export const COUNTRIES = [
  'India',
  'United States',
  'United Kingdom',
  'Canada',
  'Australia',
  'United Arab Emirates',
  'Singapore',
  'Germany',
  'France',
  'Japan',
  'China',
  'Sri Lanka',
  'Nepal',
  'Bangladesh',
  'Pakistan',
  'Malaysia',
  'Thailand',
  'Indonesia',
  'Saudi Arabia',
  'Qatar',
  'Oman',
  'Kuwait',
  'Bahrain',
  'New Zealand',
  'South Africa',
  'Italy',
  'Spain',
  'Netherlands',
  'Switzerland',
  'Other',
];

export const INDIAN_CITIES = [
  'Hyderabad',
  'Secunderabad',
  'Shamshabad',
  'Bangalore',
  'Bengaluru',
  'Chennai',
  'Mumbai',
  'Delhi',
  'New Delhi',
  'Kolkata',
  'Pune',
  'Ahmedabad',
  'Jaipur',
  'Lucknow',
  'Chandigarh',
  'Kochi',
  'Visakhapatnam',
  'Vijayawada',
  'Tirupati',
  'Warangal',
  'Nizamabad',
  'Karimnagar',
  'Khammam',
  'Nalgonda',
  'Guntur',
  'Nellore',
  'Coimbatore',
  'Madurai',
  'Mysuru',
  'Surat',
  'Indore',
  'Bhopal',
  'Nagpur',
  'Patna',
  'Guwahati',
  'Thiruvananthapuram',
  'Goa',
  'Varanasi',
  'Agra',
  'Noida',
  'Gurugram',
  'Faridabad',
  'Ghaziabad',
];

export const fetchLocationByPinCode = async (pinCode) => {
  if (!/^\d{6}$/.test(pinCode)) {
    return null;
  }

  try {
    const response = await fetch(`https://api.postalpincode.in/pincode/${pinCode}`);
    if (!response.ok) {
      return null;
    }

    const [result] = await response.json();
    if (result?.Status !== 'Success' || !result.PostOffice?.length) {
      return null;
    }

    const postOffice = result.PostOffice[0];
    const city =
      postOffice.District ||
      postOffice.Block ||
      postOffice.Name ||
      '';
    const country = postOffice.Country || 'India';
    const extraCities = result.PostOffice.map(
      (office) => office.Name || office.District
    ).filter(Boolean);

    return { city, country, extraCities };
  } catch {
    return null;
  }
};
